import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Truck, Wrench, ShieldCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./motion";

const FACTS = [
  { icon: Truck, t: "Entrega", d: "Levamos o material até a sua casa ou obra." },
  { icon: Wrench, t: "Orientação técnica", d: "Profissionais que tiram todas as dúvidas antes da compra." },
  { icon: ShieldCheck, t: "Marcas de confiança", d: "Komeco, Rinnai, Tigre, Jacuzzi e muito mais." },
];

export const Store = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <section id="loja" ref={ref} className="relative bg-[#0A0E3F] text-white py-24 md:py-36 overflow-hidden grain" data-testid="store-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <Reveal className="lg:col-span-6 order-2 lg:order-1">
          <div className="relative rounded-[28px] overflow-hidden h-[460px] md:h-[620px] ring-1 ring-white/10" data-testid="store-photo">
            <motion.img style={{ y: imgY }} src="/img/fachada.jpg" alt="Loja RSilva na Avenida Santos Dumont" className="absolute inset-0 w-full h-[116%] -top-[8%] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-tr from-[#0A0E3F]/70 via-transparent to-transparent" />
            <img src="/img/logo-rsilva.png" alt="Logo RSilva Aquecimento Solar e Bombas" className="absolute bottom-5 left-5 w-40 md:w-52 rounded-xl shadow-2xl" />
          </div>
        </Reveal>
        <div className="lg:col-span-6 order-1 lg:order-2 lg:pl-8">
          <Reveal>
            <Eyebrow>A loja</Eyebrow>
            <h2 className="mt-6 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-[-0.03em] leading-[0.95]">
              Venha conhecer a loja no <span className="italic text-[#FFB020]">Centro de Lauro.</span>
            </h2>
            <p className="mt-8 text-base md:text-lg text-white/80 leading-relaxed max-w-xl">
              Prateleiras cheias de boilers, coletores solares, resistências, aquecedores a gás, Aquatherm, PVC, PPR, Multicamada, PEAD, válvulas e produtos para piscina. Fornecedor de sistemas de aquecimento solar com atendimento de perto.
            </p>
          </Reveal>
          <div className="mt-12 grid sm:grid-cols-3 gap-4">
            {FACTS.map(({ icon: I, t, d }, i) => (
              <Reveal key={t} delay={0.1 * i}>
                <div className="group h-full rounded-2xl border border-white/10 bg-white/[0.03] p-5 hover:border-[#FF6A13]/60 hover:bg-white/[0.06] transition-colors duration-500" data-testid={`store-fact-${i}`}>
                  <I className="w-6 h-6 text-[#FF6A13] transition-transform duration-500 group-hover:-translate-y-1" />
                  <p className="mt-4 font-display font-bold">{t}</p>
                  <p className="mt-2 text-sm text-white/70 leading-relaxed">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
